// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAlertsEwiCheck_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6" cy="6" r="5.25" class="svg-bg"/>
  <path d="M3.32721 4.88098L2.073 6.13519L5.20835 9.27103L10.2252 4.25421L8.97097 3L5.2086 6.76237L3.32721 4.88098Z" class="svg-fg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="7" class="svg-bg"/>
  <path d="M5.21279 7.17976L3.88574 8.50681L7.20321 11.8247L12.5114 6.51651L11.1844 5.18945L7.20343 9.17039L5.21279 7.17976Z" class="svg-fg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" class="svg-bg"/>
  <path d="M8.12981 10.6248L6.22778 12.5268L9.08109 15.3801L9.07965 15.3816L10.9817 17.2836L18.5898 9.67547L16.6878 7.77344L10.9831 13.4781L8.12981 10.6248Z" class="svg-fg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16Z" class="svg-bg"/>
  <path d="M11.1203 14.3755L8.88159 16.6143L14.4783 22.2113L23.4333 13.2563L21.1945 11.0176L14.4785 17.7336L11.1203 14.3755Z" class="svg-fg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="32" cy="32" r="30" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5962 27.7175L16 32.3137L24.4853 40.799L28.7279 45.0416L33.3241 40.4454L48.5269 25.2426L44.2843 21L29.0815 36.2028L20.5962 27.7175Z" class="svg-fg"/>
</svg>
`;
/**
 * IconAlertsEwiCheck is a generated icon component.
 */
let IconAlertsEwiCheck = IconAlertsEwiCheck_1 = class IconAlertsEwiCheck extends IconBaseElement {
    render() {
        return html `${IconAlertsEwiCheck_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAlertsEwiCheck.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconAlertsEwiCheck = IconAlertsEwiCheck_1 = __decorate([
    customElement('zui-icon-alerts-ewi-check')
], IconAlertsEwiCheck);
export { IconAlertsEwiCheck };
